<template>
  <section class="projects-section">
    <h1 class="title">
      <span class="light">RECENT</span>
      <span class="dark">PROJECTS</span>
    </h1>
    <div class="cards-container">
      <ProjectCard
        image="disposition-shortcuts.png"
        title="Disposition Shortcuts for VICIdial"
        subtitle="Chrome Extension | JavaScript"
        url="/disposition-shortcuts/vicidial.php/index.html"
      />
      <ProjectCard
        image="https://i.postimg.cc/vHxydqyq/image.png"
        title="IGCSEMaster"
        subtitle="Next.js "
        url="https://igcsemaster.vercel.app/"
      />
      <ProjectCard
        image="https://i.postimg.cc/SQX3XnPs/image.png"
        title="Greenleaf"
        subtitle="html | CSS | JavaScript"
        url="https://green-leaf-ashy.vercel.app/"
      />

      <ProjectCard
        image="Restaurant.png"
        title="One Stop Restaurant Management System"
        subtitle="Next.js "
        url="https://github.com/Saad-Mehboob-824/Restaurant"
      />
      <ProjectCard
        image="RPS.png"
        title="Rock Paper Scissors with gesture recognition"
        subtitle="Python | TensorFlow | OpenCV | AI/ML"
        url="https://github.com/Saad-Mehboob-824/Rock-Paper-Scisors"
      />
      <ProjectCard
        image="chess.png"
        title="Chess with alpha beta pruning(AI)"
        subtitle="Python | AI | Gameplay"
        url="https://www.linkedin.com/posts/muhammad-saad-mehboob-125829247_python-ai-chess-activity-7331413699984801792-6z8G?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD0rL20BcOntfGjfysk---5yMPEWJcjeNKo"
      />
      <ProjectCard
        image="lunar.png"
        title="Lunar Match"
        subtitle="REACT | Gameplay"
        url="https://lunar-match.vercel.app/"
      />
    </div>
        <button class="see-all-btn">See All</button>
  </section>
</template>

<script>
import ProjectCard from '../components/Project.vue'

export default {
  name: 'ProjectsSection',
  components: { ProjectCard }
}
</script>         

<style scoped>
.projects-section {
  background-color: #0f0d0d;
  padding: 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px;
  
}

.title {
  font-size: 2.5rem;
  font-weight: 900;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column; /* Stack RECENT and PROJECTS vertically */
}

.light {
  color: white;
}

.dark {
  color: #3d3d3d;
}

.cards-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center each ProjectCard */
  gap: 20px; /* Space between cards */
}

.see-all-btn {
  background-color: #1a73e800;
  color: white;
  border-width: 2;
  border-color: antiquewhite;
  border: none;
  padding: 10px 20px;
  font-size: 1rem;
  border-radius: 5px;
  cursor: pointer;
  /* margin-top: 20px; */
  transition: background-color 0.3s;
}

.see-all-btn:hover {
  background-color: #386197;
}
</style>